
import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { updateCart } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { chain, UpdateCart, LoadCart } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(
    chain,
    UpdateCart,
    props => {
        if (!props.updateCartApiParameter) {
            return;
        }
        updateCart(props.updateCartApiParameter);
    },
);

replaceInChain(
    chain,
    LoadCart,
    props => {
        props.dispatch(loadCurrentCart({ shouldLoadFullCart: false }));
    },
);

